/**
 * @author       chenzhongyi <chenzhongyi@tuzhanai.com>
 * @copyright    2018 Zhongyi Chen.
 */

const _winWidth = window.innerWidth;

// 初始化根部字体大小（设置rem单位大小）
document.documentElement.style.fontSize = `${_winWidth / 100}px`;
